import React, { Fragment } from "react";

import HeaderLogo from "../AppLogo";
import UserBox from "./Components/UserBox";
import { CSSTransitionComponent } from "../../components/CSSTransition";
import SearchModal from "./Components/SearchModal";
import { utils } from "../../utils/utils";
import ThemeToggle from "../../components/ThemeToggle";
import { Menu, Search } from "lucide-react";
import { useSidebarStore } from "../../stores/sidebarStore";

interface AppHeaderState {
    searchOpen: boolean;
}

class AppHeader extends React.Component<any, AppHeaderState> {
    constructor(props: any) {
        super(props);
        this.state = {
            searchOpen: false,
        };
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = (e: KeyboardEvent) => {
        // Cmd+K or Ctrl+K to open search
        if ((e.metaKey || e.ctrlKey) && e.key === "k") {
            e.preventDefault();
            this.setState({ searchOpen: true });
        }
    };

    handleToggle = () => {
        const { toggleSidebar } = this.props;
        const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
        if (isDesktop) {
            useSidebarStore.getState().toggleCollapsed();
        } else {
            toggleSidebar();
        }
    };

    render() {
        return (
            <Fragment>
                <CSSTransitionComponent>
                    <div
                        className="app-header fixed top-0 left-0 right-0 z-50 flex items-center h-16 bg-white/80 dark:bg-neutral-900/80 backdrop-blur-lg border-b border-gray-200/50 dark:border-neutral-800/50 shadow-sm transition-all duration-200"
                    >
                        {/* Left: App Logo */}
                        <HeaderLogo />

                        {/* Left: Menu toggle */}
                        <div className="flex items-center ml-3">
                            <button
                                type="button"
                                onClick={this.handleToggle}
                                className="lg:hidden p-2 rounded-xl hover:bg-primary-50 dark:hover:bg-primary-900/20 hover:shadow-sm transition-all group"
                                aria-label="Toggle menu"
                            >
                                <Menu className="h-6 w-6 text-gray-600 dark:text-neutral-300 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors" />
                            </button>
                        </div>

                        {/* Right: Actions */}
                        <div className="app-header__content flex items-center w-full">
                            <div className="app-header-right flex items-center ml-auto gap-3">
                                {/* Search trigger button */}
                                {!utils.shouldHideGlobalSearch() && (
                                    <button
                                        type="button"
                                        onClick={() => this.setState({ searchOpen: true })}
                                        className="flex items-center gap-2 px-3 py-2 rounded-xl bg-gray-50 dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 hover:bg-gray-100 dark:hover:bg-neutral-700 transition-all group"
                                        title="Search (⌘K)"
                                    >
                                        <Search className="h-4 w-4 text-gray-400 dark:text-neutral-500" />
                                        <span className="hidden md:inline text-sm text-gray-400 dark:text-neutral-500">Search...</span>
                                        <kbd className="hidden lg:inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-semibold text-gray-400 dark:text-neutral-500 bg-white dark:bg-neutral-900 border border-gray-200 dark:border-neutral-700 rounded">
                                            <span>⌘</span>K
                                        </kbd>
                                    </button>
                                )}

                                <ThemeToggle />
                                <UserBox />
                            </div>
                        </div>
                    </div>
                </CSSTransitionComponent>

                {/* Search Modal */}
                <SearchModal
                    isOpen={this.state.searchOpen}
                    onClose={() => this.setState({ searchOpen: false })}
                />
            </Fragment>
        );
    }
}

export default AppHeader;
